import axios from 'axios';

export default ({ version = 'v5', authToken } = {}) => {
  const config = {
    baseURL: `/api/${version}/`,
  };

  const instance = axios.create(config);

  if (authToken) {
    instance.defaults.headers.common['X-User-Token'] = authToken;
  }

  return instance;
};
